import React from 'react';

import { ErrorCard } from '@eika/card';
import { CheckmarkAnimation } from '@eika/checkmark-animation';

import { Piwik, SiteCoreDictionary, SoftBlockLoader } from '../types';

import './SuccessReceipt.scss';

interface ReceiptProps {
    softBlockLoader: SoftBlockLoader;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Receipt = ({ softBlockLoader, dictionary, piwik }: ReceiptProps) => {
    const { blockStatusSoft, messageErrorUps, orderBankCardFailureText } = dictionary;
    const { hasSoftBlockedCard } = softBlockLoader;

    if (hasSoftBlockedCard) {
        return (
            <div
                className="success-container"
                data-track-id={piwik?.blockCardForm?.softBlockCardSuccessReceipt?.dataTrackId}
                data-track-linkname={piwik?.blockCardForm?.softBlockCardSuccessReceipt?.dataTrackLinkname}
                id={piwik?.blockCardForm?.softBlockCardSuccessReceipt?.dataTrackId}
            >
                <CheckmarkAnimation key="success-hard-block" />
                <h3 className="success-header">{blockStatusSoft}</h3>
            </div>
        );
    }

    return (
        <ErrorCard
            data-track-id={piwik?.blockCardForm?.softBlockCardError?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.softBlockCardError?.dataTrackLinkname}
            id={piwik?.blockCardForm?.softBlockCardError?.dataTrackId}
            title={messageErrorUps}
            description={orderBankCardFailureText}
        />
    );
};

export default Receipt;
